import {
	CHECK_USER_EMAIL_EXISTS,
	FIREBASE_SEND_FORGOT_PWD
} from "./../../store/actions.type";
import { mapActions } from "vuex";
import { required, email } from 'vuelidate/lib/validators'
export default {
	data () {
		return {
			email: "",
			forgotLoading: true
		};
	},
	created () {

	},
	validations: {
		email: {
			required
		}
	},
	methods: {
		...mapActions({
			checkemailexists: CHECK_USER_EMAIL_EXISTS,
			firebasesendforgotpassword: FIREBASE_SEND_FORGOT_PWD
		}),


		validatesendForgotPassword () {

			this.$validator.validateAll().then((result) => {
				if (result) {
					this.sendForgotPassword();
				}
			});


		},

		async sendForgotPassword () {
			this.forgotLoading = false
			var userData = {};
			userData["email"] = this.email;

			await this.checkemailexists(this.email).then(data => {
				if (data.success) {
					this.firebasesendforgotpassword(userData).then(result => {
						if (result) {
							this.$notify({
								group: 'allAlerts',
								title: '',
								type: 'success',
								text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-success fa fa-check-circle" aria-hidden="true"></i></span> <span class="notificationText">Password Reset sent to your email id </span></div>'
							});

						} else {
							this.$notify({
								group: 'allAlerts',
								title: '',
								type: 'error',
								text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">Password Reset sending failed, Please try again! </span></div>'
							});


						}
					});
				}
				else if (!data.success && data.message && data.message.length > 0) {
					this.$notify({
						group: 'allAlerts',
						title: '',
						type: 'warn',
						text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-warn fa fa-exclamation-triangle" aria-hidden="true"></i></span> <span class="notificationText">'+data.message +' </span></div>'
					});
				}
				else {

					this.$notify({
						group: 'allAlerts',
						title: '',
						type: 'warn',
						text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-warn fa fa-exclamation-triangle" aria-hidden="true"></i></span> <span class="notificationText">User not found with this Email Id </span></div>'
					});

				};
			});
			this.forgotLoading = true
		}
	}
};



// WEBPACK FOOTER //
// ./src/assets/js/forgotpassword.js